import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "@/components/ui/card";
import { UtensilsCrossed, Cake, Soup, Coffee } from "lucide-react";
const categories = [
    {
        name: "Main Dishes",
        icon: UtensilsCrossed,
        count: "124 recipes",
        color: "watercolor-peach",
    },
    {
        name: "Desserts",
        icon: Cake,
        count: "89 recipes",
        color: "watercolor-butter",
    },
    {
        name: "Soups & Stews",
        icon: Soup,
        count: "67 recipes",
        color: "watercolor-sage",
    },
    {
        name: "Breakfast",
        icon: Coffee,
        count: "52 recipes",
        color: "watercolor-peach",
    },
];
export function CategoryCards() {
    return (_jsx("section", { className: "py-16 bg-muted/30", children: _jsxs("div", { className: "container mx-auto px-4", children: [_jsx("div", { className: "text-center mb-12", children: _jsx("h2", { className: "text-5xl md:text-6xl text-foreground", children: "Browse by Category" }) }), _jsx("div", { className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-6", children: categories.map((category) => {
                        const Icon = category.icon;
                        return (_jsxs(Card, { className: "p-6 cursor-pointer hover:translate-y-[-4px] transition-all shadow-vintage-sm hover:shadow-vintage border-2 group", children: [_jsx("div", { className: `w-16 h-16 rounded-2xl ${category.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`, children: _jsx(Icon, { className: "w-8 h-8 text-foreground" }) }), _jsx("h3", { className: "mb-2", children: category.name }), _jsx("p", { className: "text-sm text-muted-foreground", children: category.count })] }, category.name));
                    }) })] }) }));
}
